import React from 'react';
import { ChefHat, UtensilsCrossed, Receipt } from 'lucide-react';
import NotificationBadge from './NotificationBadge';

interface ComandaBottomBarProps {
  total: number;
  itensPendentesCozinha: number;
  onEnviarCozinha: () => void;
  activeTab?: 'cardapio' | 'carrinho';
  onTabChange?: (tab: 'cardapio' | 'carrinho') => void;
  itensCount?: number;
  isOwner?: boolean;
}

const ComandaBottomBar: React.FC<ComandaBottomBarProps> = ({
  total,
  itensPendentesCozinha,
  onEnviarCozinha,
  activeTab = 'cardapio',
  onTabChange,
  itensCount = 0,
}) => {
  const temItensPendentes = itensPendentesCozinha > 0;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-gray-900/95 border-t border-gray-700/50 shadow-2xl backdrop-blur-md"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-center px-3 py-2 gap-3">

        {/* Abas cardápio / comanda */}
        <div className="flex bg-gray-800 p-1 rounded-xl border border-gray-700/50 gap-1">
          <button
            onClick={() => onTabChange?.('cardapio')}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold transition-all touch-manipulation ${
              activeTab === 'cardapio'
                ? 'bg-orange-500 text-white shadow-md'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <UtensilsCrossed className="h-4 w-4" />
            <span>Cardápio</span>
          </button>

          <button
            onClick={() => onTabChange?.('carrinho')}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold transition-all touch-manipulation relative ${
              activeTab === 'carrinho'
                ? 'bg-orange-500 text-white shadow-md'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <Receipt className="h-4 w-4" />
            <span>Comanda</span>
            {itensCount > 0 && activeTab !== 'carrinho' && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-bold w-4 h-4 flex items-center justify-center rounded-full border border-gray-800">
                {itensCount > 9 ? '9+' : itensCount}
              </span>
            )}
          </button>
        </div>

        {/* Total + botão enviar */}
        <div className="flex items-center gap-2 flex-1 justify-end">
          <div className="text-right">
            <p className="text-[10px] text-gray-500 leading-none">Total</p>
            <p className="text-base font-bold text-orange-400 leading-tight">R$ {total.toFixed(2)}</p>
          </div>

          {temItensPendentes && (
            <button
              onClick={onEnviarCozinha}
              className="flex items-center gap-1.5 px-4 py-2.5 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white rounded-xl font-semibold text-xs transition-all shadow-lg active:scale-95 touch-manipulation relative"
            >
              <ChefHat className="h-4 w-4 flex-shrink-0" />
              <span>Enviar</span>
              <NotificationBadge count={itensPendentesCozinha} />
            </button>
          )}
        </div>

      </div>
    </div>
  );
};

export default ComandaBottomBar;
